export default class PosteRealiseDto {
  id;
  codeRome;
  nbRecrutement;
  typesContrat = [];
  formation;
  dureesContrat = [];
  integrationEntreprise;
  sortieEntreprise;
  isTouched;
}
